// #region TYPES
const USER_PREFS_SET_TEMP = 'USER_PREFS_SET_TEMP';
const USER_PREFS_SET_ASSETFILTERS = 'USER_PREFS_SET_ASSETFILTERS';
// #endregion TYPES

const initState = {
  temp: 'Fahrenheit',
  assetFilters: [],
};

export function userPrefsSetTempAction(temp) {
  return {
    type: USER_PREFS_SET_TEMP,
    temp,
  };
}

function handleSetTemp(state, { temp }) {
  return {
    ...state,
    temp,
  };
}

export function userPrefsSetAssetFiltersAction(assetFilters) {
  return {
    type: USER_PREFS_SET_ASSETFILTERS,
    assetFilters,
  };
}

function handleSetAssetFilters(state, { assetFilters }) {
  return {
    ...state,
    assetFilters,
  };
}

const actionHandler = {
  [USER_PREFS_SET_TEMP]: handleSetTemp,
  [USER_PREFS_SET_ASSETFILTERS]: handleSetAssetFilters,
};

const reducer = (state = initState, action) => {
  const handlerFn = actionHandler[action.type];

  if (!handlerFn) return state;

  return handlerFn(state, action);
};

export default reducer;
